import { defineMessages } from 'react-intl';

export const scope = 'app.utils';

export default defineMessages({
  ht: {
    defaultMessage: 'Hawaii Time (Honolulu)',
  },
  akt: {
    defaultMessage: 'Alaska Time (Anchorage)',
  },
  usEt: {
    defaultMessage: 'Eastern Time (New York)',
  },
  usCt: {
    defaultMessage: 'Central Time (Chicago)',
  },
  usMt: {
    defaultMessage: 'Mountain Time (Denver)',
  },
  usArizona: {
    defaultMessage: 'Arizona Time (Phoenix)',
  },
  usPt: {
    defaultMessage: 'Pacific Time (Los Angeles)',
  },
  pt: {
    defaultMessage: 'Pacific Time (Vancouver)',
  },
  mt: {
    defaultMessage: 'Alberta Time (Edmonton)',
  },
  nwt: {
    defaultMessage: 'Northwest Territories Time (Inuvik)',
  },
  ct: {
    defaultMessage: 'Manitoba Standard Time (Winnipeg)',
  },
  et: {
    defaultMessage: 'Eastern Time (Toronto)',
  },
  at: {
    defaultMessage: 'Atlantic Time (Halifax)',
  },
  st: {
    defaultMessage: 'Central Standard Time (Swift Current)',
  },
  nt: {
    defaultMessage: 'Newfoundland Time (St. John’s)',
  },
  mst: {
    defaultMessage: 'Yukon Standard Time',
  },
  est: {
    defaultMessage: 'Eastern Standard Time (Atikokan)',
  },
});
